import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p){
  const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; // Size of grid squares

  // Draw grid much larger than canvas so it doesn't "run out" during camera movement
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
      p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
      p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

function Internetloading({p5ref, wt, ht, scale, fs, bgcolor}) {
  const sketch = (p) => {
    // --- Colors ---
    let BLACK = [51, 51, 51];
    let PINK = [235, 93, 123];
    let BLUE = [93, 105, 235];
    let BEIGE = [255, 254, 246];

    let firstText = "Before marrying someone, have them use slow internet";
    let secondText = "to see who they really are.";
    let latoFont;
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;

    // Spinner animation
    let spinnerAngle = 0;
    let spinnerSize = 30;

    // char spacing table
    const letter_extra_space = {
      a: 1,
      b: 1,
      c: 1,
      d: 1,
      e: 1.5,
      f: 0,
      g: 1,
      h: 1,
      i: 1,
      j: 1,
      k: 1,
      l: 1,
      m: 1,
      n: 1,
      o: 1,
      p: 1,
      q: 1,
      r: -0.2,
      s: 2,
      t: 0,
      u: 1,
      v: 0,
      w: 1,
      x: 1,
      y: 1,
      z: 1,
      A: 1,
      B: 1,
      C: 1,
      D: 1,
      E: 1,
      F: 1,
      G: 1,
      H: 1,
      I: 1,
      J: 1,
      K: 1,
      L: 0.5,
      M: 1,
      N: 1,
      O: 1,
      P: 1,
      Q: 1,
      R: 1,
      S: 1,
      T: 1,
      U: 1,
      V: 1,
      W: 1,
      X: 1,
      Y: 1,
      Z: 1,
    };

    // LOAD GOOGLE FONT
    function preloadFont(url) {
      return new Promise((resolve) => {
        const link = document.createElement("link");
        link.href = url;
        link.rel = "stylesheet";
        link.onload = resolve;
        document.head.appendChild(link);
      });
    }

    p.setup = async () => {
      await preloadFont(
        "https://fonts.googleapis.com/css2?family=Lato&display=swap"
      );

      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textSize(fs);
      p.textAlign(p.LEFT, p.CENTER);

      try {
        p.textFont("Lato");
      } catch (e) {
        p.textFont("sans-serif");
      }

      // Precompute char widths
      for (let i = 0; i < firstText.length; i++) {
        let w = p.textWidth(firstText[i]);
        feelWidths[i] =
          w +
          (firstText[i] === " "
            ? spaceKerning
            : letter_extra_space[firstText[i]] || 0);
      }

      for (let i = 0; i < secondText.length; i++) {
        let w = p.textWidth(secondText[i]);
        doWidths[i] =
          w +
          (secondText[i] === " "
            ? spaceKerning
            : letter_extra_space[secondText[i]] || 0);
      }

   
    };

    function drawSpinner() {
      p.push();
      p.translate(p.width / 2, p.height / 2);
      p.rotate(spinnerAngle);
      p.stroke(BLACK);
      p.strokeWeight(3);
      p.noFill();
      let pulse = Math.sin(p.frameCount * 0.05) * 2;
      p.arc(0, 0, spinnerSize + pulse, spinnerSize + pulse, 0, p.PI / 2);
      spinnerAngle += 0.05;
      p.pop();
    }

    function drawStaticText() {
      p.push();
      p.textSize(fs);
      p.textFont("Lato");
      p.textAlign(p.LEFT, p.CENTER);

      let cx = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;

      let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
      let secondWidth = doWidths.reduce((a, b) => a + b, 0);

      let x1 = cx - firstWidth / 2;
      let x2 = cx - secondWidth / 2;

      p.fill(BLACK);

      // first line
      let xx = x1;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], xx, firstY);
        xx += feelWidths[i];
      }

      // second line
      xx = x2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], xx, secondY);
        xx += doWidths[i];
      }

      p.pop();
    }

    p.keyTyped = () => {
      if (p.key === "s" && recording) {
        recorder.stop();
        recording = false;
      }
    };

    p.draw = () => {
      p.background(BEIGE);
      grid(p);
      drawSpinner();
      drawStaticText();
    };
  };

  return <div style={{ backgroundColor: bgcolor }}>
  <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
    <ReactP5Wrapper sketch={sketch} />
  </div>
</div>
}

export default Internetloading